<template>
  <v-card
    flat
  >
    <v-card-title>
      <v-icon
        left
        :disabled="!isGood"
        color="primary"
      >
        mdi-truck
      </v-icon>
      Ship to:
    </v-card-title>
    <v-card-text>
      <v-text-field
        v-model="address.line1"
        label="Address"
      />
      <v-text-field
        v-model="address.line2"
        label="Line 2"
      />
      <v-text-field
        v-model="address.city"
        label="City"
      />
      <v-select
        v-model="address.state"
        label="State"
        :items="states"
      />
      <v-text-field
        v-model="address.postal_code"
        label="Postal Code"
      />
      <v-text-field
        v-if="false"
        v-model="address.country"
        label="Country"
      />
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    isGood: {
      type: Boolean,
    },
  },
  data() {
    return {
      address: {}
    }
  },
  computed: {
    states() {
      return this.mbStates
    }
  },
  watch: {
    address: {
      handler(address) {
        this.$emit('changed', { address })
      },
      deep: true
    }
  },
}
</script>